export enum TooltipPlacement {
    BOTTOM = 'bottom',
    TOP = 'top'
}
